import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { Grid } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { useStyles, styles, BackToListButton } from './SuccessConfirmation.styles';
import CloseButton from '../buttons/CloseButtton.component';

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      {children}
    </MuiDialogTitle>
  );
});

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface ISuccessDataProps {
  temporaryArg: boolean;
  isSuccessArg: boolean;
  closeArg: boolean;
  mail?: string;
  successDataToParent: (close: boolean) => void;
}

const SuccessConfirmation: React.FC<ISuccessDataProps> = ({ isSuccessArg, mail, successDataToParent }) => {
  const classes = useStyles();

  const handleClose = () => {
    successDataToParent(true);
  };

  return (
    <>
      <DialogTitle id="confirmation" onClose={handleClose}>
        {isSuccessArg ? (
          <Grid container>
            <Grid item xs={12}>
              <CloseButton onClick={handleClose} />
            </Grid>
            <Grid>
              <div className={classes.successCheck}>
                <CheckCircleIcon style={{ fontSize: '59px', color: '#347F42' }} />
              </div>
            </Grid>

            <Grid className={classes.message}>
              <div className={classes.text}>Link aktywacyjny został wysłany na:</div>
              <div className={classes.text}>{mail}</div>
            </Grid>
            <Grid>
              <div className={classes.backToList}>
                <BackToListButton onClick={handleClose}>Powrót do listy</BackToListButton>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <CloseButton onClick={handleClose} />
            </Grid>
            <Grid>
              <div className={classes.unsuccessCheck}>
                <CancelIcon style={{ fontSize: '59px', color: '#BC0000' }} />
              </div>
            </Grid>

            <Grid>
              <div className={classes.textUnsuccessPrimary}>Dodawanie nowego użytkownika nie powiodło się.</div>
              <div className={classes.textUnsuccessSecondary}>Spróbuj ponownie później</div>
            </Grid>
            <Grid>
              <div className={classes.backToListSecondary}>
                <BackToListButton onClick={handleClose}>Powrót do listy</BackToListButton>
              </div>
            </Grid>
          </Grid>
        )}
      </DialogTitle>
    </>
  );
};

export default SuccessConfirmation;
